const Avatar = (props) => {
    return <svg width={props?.size || "125"} height={props?.size || "125"} className={props.className} viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="125" height="125" rx="62.5" fill="#F2F4F7" />
        <path d="M42 81.6667C47.4502 75.886 54.8497 72.3333 63 72.3333C71.1503 72.3333 78.5498 75.886 84 81.6667M73.5 52.5C73.5 58.299 68.799 63 63 63C57.201 63 52.5 58.299 52.5 52.5C52.5 46.701 57.201 42 63 42C68.799 42 73.5 46.701 73.5 52.5Z" stroke="#475467" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
}

export default Avatar;